var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-progress-bar round-border",class:_vm.variant,on:{"click":function($event){return _vm.$emit('progressBarClicked')}}},[_c('div',{staticClass:"progressbar round-border",class:_vm.variant,style:(_vm.width)})])}
var staticRenderFns = []

export { render, staticRenderFns }